import React from 'react';
import { Alert } from '@/components/ui/alert';

import { useNamespacedTranslation } from '../../../../../../../hooks/useNamespacedTranslation';
import FlairIcon from '../../../../../../../atomic/atoms/FlairIcon';

type SalaryWarningAlertProps = {
  hasValidInput: boolean;
  percentageChange: number;
};

export const SalaryWarningAlert: React.FC<
  React.PropsWithChildren<SalaryWarningAlertProps>
> = ({ hasValidInput, percentageChange }) => {
  const t = useNamespacedTranslation('changeRequests.requestForm.salaryChange');

  if (!hasValidInput) return null;

  const isLargeChange = Math.abs(percentageChange) > 33;
  if (!isLargeChange) return null;

  let warningLabel = t('changeRepresentsPercentage')
    .replace('{{percentage}}', Math.abs(percentageChange).toFixed(1))
    .replace(
      '{{direction}}',
      t(percentageChange > 0 ? 'increase' : 'decrease'),
    );

  return (
    <Alert variant="warning" className="mt-3 d-flex align-items-start">
      <FlairIcon
        icon="alert-triangle-outline"
        size="sm"
        className="me-2 mt-1"
      />
      <div>
        <div className="fw-bold mb-1" style={{ fontSize: '0.875rem' }}>
          {t('significantChangeDetected')}
        </div>
        <div className="mb-0">{warningLabel}</div>
      </div>
    </Alert>
  );
};
